module.exports = __webpack_public_path__ + "img/3_179.1f25d340.png";